import { render } from "./MinesControls.vue?vue&type=template&id=2be61e46&scoped=true"
import script from "./MinesControls.vue?vue&type=script&lang=js"
export * from "./MinesControls.vue?vue&type=script&lang=js"

import "./MinesControls.vue?vue&type=style&index=0&id=2be61e46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be61e46"]])

export default __exports__